"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviewGamesList = void 0;
var PreviewGamesList_1 = require("./PreviewGamesList");
Object.defineProperty(exports, "PreviewGamesList", { enumerable: true, get: function () { return __importDefault(PreviewGamesList_1).default; } });
